module.exports = __webpack_public_path__ + "static/media/logo.b3bedb75.svg";